<template>
  <div class="compressed-content">
    <h3 class="page-question">Do you use smokeless tobacco? How many years have you used smokeless tobacco?</h3>

    <div class="page-buttons">
      <v-form-group class="card-selector">
        <b-form-radio v-model="survey.smoking.isUsingSmokeless" name="yes" value="true">Yes</b-form-radio>
        <b-form-radio v-model="survey.smoking.isUsingSmokeless" name="no" value="false">No</b-form-radio>
      </v-form-group>

      <v-form-group :validator="$v.yearsUsingSmokeless" label="Years smokeless">
        <b-form-input slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="survey.smoking.yearsUsingSmokeless"
                      placeholder="Years smokeless" />
      </v-form-group>
    </div>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required, between, numeric } from "vuelidate/lib/validators";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');

  export default {
    mixins: [formMixin],

    validations: {
      yearsUsingSmokeless: {
        required,
        between: between(1, 80),
        numeric
      }
    },

    computed: {
      ...mapState(["survey"]),

      yearsUsingSmokeless() { return this.survey.smoking.yearsUsingSmokeless; },
    }
  };
</script>
